import React, { useState } from 'react';
import * as S from 'styles';
import * as C from 'components';

export function FindId(props) {
  const [step, setStep] = useState('step1');

  const sampleData = {
    userName: '홍길동',
    carrier: '2',
    phone: '01012341234',
    phoneCode: '123456',
  };

  const [values, setValues] = useState({
    userName: '',
    carrier: '',
    phone: '',
    phoneCode: '',
  });

  return (
    <>
      <C.AppBar>아이디 찾기</C.AppBar>
      <S.Div $padding="20px">
        {step === 'step1' && <C.AuthStep1 setStep={setStep} />}
        {step === 'step2' && (
          <C.AuthStep2 setStep={setStep} values={values} setValues={setValues} sampleData={sampleData} />
        )}
        {step === 'success' && <C.Success type="id" />}
        {step === 'failed' && <C.Failed type="id" />}
      </S.Div>
    </>
  );
}
